import React, { useState, useEffect, useContext } from "react";
import InputV2 from "../../../material/input/InputV2";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import CheckBoxV2 from "../../../material/checkboxV2/CheckBoxV2";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import { RedirectCode400 } from "../../../RedirectCode400";
import Select from "../../../material/select/SelectV2";

export default function AddMenuManagement() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [typeOptions, setTypeOptions] = useState([]);
  const [input, setInput] = useState({
    role: location.state?.role || "",
    name: location.state?.name || "",
    url: location.state?.url || "",
    weight: location.state?.weight || "",
    parent_id: location.state?.parent_id || "",
    external: location.state?.external || false,
    active: location.state?.active || true,
  });

  const onChange = (id, value) => {
    setInput((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const addMenu = async () => {
    if (!input.url) {
      setIsMessage({ type: "warning", data: "เกิดกรอกลิงก์" });
    }
    let res = await adminApi.addMenu(input);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/menu/menu-list");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateMenu = async () => {
    let res = await adminApi.updateMenu(location.state?.id, input);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/menu/menu-list");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getParent = async () => {
    let res = await adminApi.getMenu("parent");
    if (res) {
      if (res["data"]["code"] === 200) {
        const formattedMenuList = Object.entries(res["data"]["menu_list"]).map(
          ([name, value]) => ({
            name,
            value,
          }),
        );
        setTypeOptions(formattedMenuList);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  useEffect(() => {
    if (location.state?.type !== "menu") {
      navigate("/");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    getParent();
  }, [location, navigate]);

  const onClickAddSubmit = (type) => {
    if (!input.name) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อเมนู" });
    } else if (isNaN(input.weight)) {
      setIsMessage({ type: "warning", data: "กรุณากรอกลำดับเป็นตัวเลข" });
      return;
    } else if (!input.role) {
      setIsMessage({ type: "warning", data: "กรุณาเลือก role" });
      return;
    } else if (input.weight < 1) {
      setIsMessage({ type: "warning", data: "ลำดับต้องมากกว่า 0" });
    } else {
      location.state?.name ? updateMenu() : addMenu();
    }
  };

  const role_list = [
    { name: "ทั่วไป", value: "PUBLIC" },
    { name: "ประชาชนทั่วไป", value: "PATIENT" },
    { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
    { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
    { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
    { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
    { name: "ผู้บริหาร", value: "EXECUTIVE" },
    { name: "โรงพยาบาล", value: "HOSPITAL" },
    { name: "ผู้ดูแลระบบ", value: "ADMIN" },
  ];

  return (
    <div className="min-w-[376px] overflow-x-auto mb-[30px] h-auto">
      <PageHeaderV2
        titlename={location.state?.name ? "แก้ไขเมนู" : "เพิ่มเมนู"}
      />
      <div className="flex flex-col gap-[10px] rounded-[6px] border-[#E2E2E4] border w-[100%] min-w-[400px] p-[17px_16px]">
        {location.state?.name ? (
          <div className="flex flex-col text-[16px] font-['Prompt']">
            เลือกเมนู
            <Select
              value={input.parent_id}
              setValue={(value) => onChange("parent_id", value)}
              list={typeOptions}
              placeholder="เลือกเมนู"
            />
          </div>
        ) : null}

        <div className="flex flex-col text-[16px] font-['Prompt']">
          เลือกประเภทผู้ใช้งาน
          <div className="">
            <Select
              value={input.role}
              list={role_list}
              setValue={(value) => onChange("role", value)}
              placeholder="เลือกประเภทผู้ใช้งาน"
            />
          </div>
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt']">
          ลำดับ
          <InputV2
            value={input.weight}
            placeholder="ลำดับ"
            onChangeEvt={(value) => onChange("weight", value)}
          />
        </div>
        <div className="flex flex-col text-[16px] font-['Prompt']">
          ชื่อเมนู
          <InputV2
            value={input.name}
            placeholder="เมนู"
            onChangeEvt={(value) => onChange("name", value)}
          />
        </div>
        <div className="flex flex-col text-[16px] font-['Prompt']">
          ลิงค์
          <InputV2
            value={input.url}
            placeholder="ลิงค์"
            onChangeEvt={(value) => onChange("url", value)}
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] items-start gap-[5px]">
          External / Internal
          <div className="flex flex-row justify-center items-start gap-[5px]">
            <input
              type="radio"
              checked={!input.external}
              onChange={() => onChange("external", false)}
              className="form-radio h-5 w-5 text-blue-500 focus:rin bg-[#A2B5BC] border-[#A2B5BC] border-[1px] border-solid cursor-pointer"
            />
            <div>เปิดแทปเดียวกัน</div>
          </div>
          <div className="flex flex-row justify-center items-start gap-[5px]">
            <input
              type="radio"
              checked={input.external}
              onChange={() => onChange("external", true)}
              className="form-radio h-5 w-5 text-blue-500 focus:rin bg-[#A2B5BC] border-[#A2B5BC] border-[1px] border-solid cursor-pointer"
            />
            <div>เปิดอีกแทป</div>
          </div>
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt']">
          สถานะ
          <div className="flex flex-row justify-center items-center w-[90px] gap-[5px]">
            <CheckBoxV2
              id="active"
              value={input.active}
              setValue={(value) => onChange("active", value)}
            />
            <div>{input.active ? "Active" : "Inactive"}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
        <button
          onClick={() => {
            navigate("/admin/management/menu");
            setInput(null);
          }}
          className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
        >
          ยกเลิก
        </button>
        <button
          onClick={() => {
            onClickAddSubmit();
          }}
          className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
        >
          บันทึก
        </button>
      </div>
    </div>
  );
}
